import React, { useState } from 'react';

import './AccordionItem.css';

import { IonItem, IonLabel } from '@ionic/react';
import { chevronUp, chevronDown } from 'ionicons/icons';

export interface AccordionItemProps {
  name: string;
  content?: string;
  lines?: 'full' | 'inset' | 'none';
  open?: boolean;
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  name,
  content,
  lines,
  children,
  open = false
}) => {
  const [expand, setExpand] = useState(open);

  return (
    <div>
      <IonItem
        button
        detail
        detailIcon={expand ? chevronUp : chevronDown}
        key={name}
        onClick={() => setExpand(!expand)}
        lines={lines ? lines : 'full'}
      >
        <IonLabel className="ion-text-wrap">{name}</IonLabel>
      </IonItem>
      <div className={`expand-wrapper ${expand ? 'expand-wrapper--open' : ''}`}>
        <div className="ion-padding">
          {content ? (
            <div
              dangerouslySetInnerHTML={{ __html: content }}
              className="accordion-item__content"
            ></div>
          ) : null}
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
